type EventNames = {
  createFile: string;
  saveFile: string;
  openFile: string;
  closeFile: string;
  deleteFile: string;
  closeAllFiles: string;
  showLoader: string;
  hideLoader: string;
  showTreeComLoader: string;
  hideTreeComLoader: string;
  globalClick: string;
  globalKeyUp: string;
  selectTreeGroup: string;
  displayWebComponents: string;
  displayUpdateComponents: string;
  displayUpdateFlowData: string;
  checkAuthToken: string;
  setAuthToken: string;
  updateTree: string;
  updateTreeDataForScript: string;
  refreshTree: string;
  setActiveComponent: string;
  showQuerySheet: string;
  lastComponentDeleted: string;
  saveComponentConfig: string;
  saveFlowTab: string;
  saveFlowTabComLevel: string;
  saveConnectionTab: string;
  updateGridData: string;
  runJSFlowTab: string;
  runJSConnectionTab: string;
  datasourceUpdated: string;
  componentUpdated: string;
  componentTextValidation: string;
  componentDependencyDetaching: string;
  flowUpdated: string;
  connectionUpdated: string;
  scriptUpdated: string;
  projectUpdated: string;
  treeUpdated: string;
  treeUpdateDatasource: string;
  groupSelect: string;
  updateFileName: string;
  updateMcsvFileName: string;
  reportDataReceived: string;
  subscribeManualPickElementDetailStarted: string;
  subscribeManualPickElementDetailEnded: string;
  subscribeManualScreenCaptureStarted: string;
  subscribeManualScreenCaptureEnded: string;
  findByClickOfElement: string;
  updateContentIframe: string;
  updateForceDatasheet: string;
  updateWireMock: string;
  updateForceAuthDatasheet: string;
  updateContentComponent: string;
  activeComponent: string;
  setFlowActiveComponent: string;
  contentIframeUpdated: string;
  removeAttrToContentIframe: string;
  createDatasourceForComponent: string;
  runAgentScript: string;
  runDbTest: string;
  runDbQueryResult: string;
  componentMode: string;
  iframesShow: string;
  iframeRecordToggle: string;
  iframeListener: string;
  createMouseHoverActivity: string;
  saveUpdatedConnection: string;
  flowData: string;
  redirectFlow: string;
  showUpdatedFlowData: string;
  connectionData: string;
  showUpdatedConnectionData: string;
  debugStepRun: string;
  debugRunAll: string;
  editeTreeName: string;
  gitFlowEvent: string;
  virtualizationEvent: string;
  gitLogEvent: string;
  iframeLoad: string;
  rightBlocksResize: string;
  saveFileData: string;
  saveMcsvFileData: string;
  importFile: string;
  importMcsvFile: string;
  removeJSFile: string;
  swapActivity: string;
  swapApiActivity: string;
  displayUpdateActivities: string;
  removeColumn: string;
  handleDBStoreColumnVariable: string;
  handleDBLoopColumnVariable: string;
  handleDatasheetEncryptColumn: string;
  handleDatasheetUserVariable: string;
  handleMasterDatasheetEncryptColumn: string;
  handleMasterDatasheetDecryptColumn: string;
  dragDropComplete: string;
  menuItemClick: string;
  selectDate: string;
  selectableClick: string;
  resizingComplete: string;
  spinnerClick: string;
  contextClick: string;
  doubleClick: string;
  keyPress: string;
  click: string;
  downloadClick: string;
  tooltip: string;
  slideComplete: string;
  autoComplete: string;
  startScreenCapture: string;
  screenShotURLGenerated: string;
  iframeCapturingPathToggle: string;
  saveFindByClickElement: string;
  sendComponentData: string;
  setWindowActivityEditStep: string;
  windowPopperReload: string;
  componentModeUiUpdate: string;
  validationModeUiUpdate: string;
  setNewCustomActivity: string;
  treeNodeName: string;
  treeGitFlow: string;
  treeVirtualization: string;
  treeGitFlowUpdated: string;
  treeVirtualizationUpdated: string;
  treeGitLog: string;
  treeGitLogUpdated: string;
  treeNodeNameUpdated: string;
  changeHelpData: string;
  createAutoComponent: string;
  handleEditRowItemModal: string;
  handleEditChildRowItemModal: string;
  handleCopyChildRowItemModal: string;
  handleDatasheetReplicateModal: string;
  handleDatasheetDescriptionModal: string;
  handleDatasheetAddRowModal: string;
  handleDatasheetRemovesModal: string;
  handleApiDatasheetReplicateModal: string;
  handleApiDatasheetDescriptionModal: string;
  handleApiDatasheetAddRowModal: string;
  handleApiDatasheetRemovesModal: string;
  updateDatasheetReplicateContent: string;
  updateOptimizedDatasheetReplicateContent: string;
  saveOptimizedDatasheetTab: string;
  updateDatasheetRemovesContent: string;
  verifyAndSaveNewActivity: string;
  updateTestDescriptionDatasheet: string;
  displayUpdatedTestDescription: string;
  handleAddTimer: string;
  handleAssertToggle: string;
  assertColor: string;
  handleJsAdd: string;
  capturingAbsolutePath: string;
  changePath: string;
  isCapturingAbsolutePath: string;
  toggleHideTree: string;
  handleDatasheetDeleteRowConfirm: string;
  handleApiDatasheetDeleteRowConfirm: string;
  handleDatasheetDeleteColumnConfirm: string;
  handleApiDatasheetDeleteColumnConfirm: string;
  handleDatasheetDeleteRowConfirmYes: string;
  handleListenBreakpointChange: string;
  flowHandleDatasheetDeleteRowConfirmYes: string;
  connectionHandleDatasheetDeleteRowConfirmYes: string;
  handleDatasheetAddingManualRow: string;
  handleDatasheetSetData: string;
  handleDatasheetSetDataMSCV: string;
  handleApiDatasheetSetData: string;
  handleDatasheetAddManualRowFunction: string;
  handleDatasheetDeleteColumnConfirmYes: string;
  handleDatasheetAddColumnModal: string;
  handleDatasheetAddColumn: string;
  handleDatasheetFind: string;
  handleDatasheetFindNext: string;
  handleDatasheetReplace: string;
  handleDatasheetReplaceAll: string;
  handleResetFind: string;
  updateDatasheetAddColumnContent: string;
  handleAddModalInputActivity: string;
  projectUserAddVariableModal: string;
  projectUserEditVariableModal: string;
  projectUserAddConnectionModal: string;
  projectUserEditConnectionModal: string;
  updateSimpleLoopActivityModal: string;
  updateNodeName: string;
  setNumberOfColumns: string;
  setMcsvNumberOfColumns: string;
  copyComponentRefreshProjects: string;
  refreshProjects: string;
  handleSaveApiActivity: string;
  handleRequestApi: string;
  publishAPIRec: string;
  publishGetProjects: string;
  publishConnection: string;
  saveDatasheetTab: string;
  apiManualSelectActivity: string;
  manualUpdateApiRec: string;
  publishApiFormReset: string;
  taskRunningFinished: string;
  responseFromExeReceived: string;
  componentTestResultSaved: string;
  runButtonClicked: string;
  apiModuleSelected: string;
  jsonEditorReload: string;
  responsejsonEditorReload: string;
  resetResponse: string;
  isResponseHeader: string;
  isRequestHeader: string;
  moveToDatasheet: string;
  changeApiChildTab: string;
  handleSaveApiConfig: string;
  agentConnectionOn: string;
  agentConnectionOff: string;
  handleCurlActivity: string;
  handleSaveCurl: string;
  handleSaveHeader: string;
  saveParameter: string;
  closeParameter: string;
  activeNumberTab: string;
  shareActivitiesData: string;
  selectResponseHeaderTab: string;
  fileUploadUpdateTree: string;
  tableHeaderChange: string;
  apiDatasheetUpload: string;
  apiDatasheetDownload: string;
  apiDatasheetTestGeneration: string;
  setActiveDataMatrixRow: string;
  getActiveDataMatrixRow: string;
  checkColumnParameterized: string;
  columnParameterizedResult: string;
  removeColumnParameterization: string;
  regenerateCurlFromRequest: string;
  pageElementsCaptured: string;
  refreshPageElements: string;
};

export const eventNames: EventNames = {
  createFile: "CREATE_FILE",
  saveFile: "SAVE_FILE",
  openFile: "OPEN_FILE",
  closeFile: "CLOSE_FILE",
  deleteFile: "DELETE_FILE",
  closeAllFiles: "CLOSE_ALL_FILES",
  showLoader: "SHOW_LOADER",
  hideLoader: "HIDE_LOADER",
  showTreeComLoader: "SHOW_TREE_COM_LOADER",
  hideTreeComLoader: "HIDE_TREE_COM_LOADER",
  globalClick: "GLOBAL_CLICK",
  globalKeyUp: "GLOBAL_KEY_UP",
  selectTreeGroup: "GROUP_SELECT_ITEMS",
  displayWebComponents: "DISPLAY_WEB_COMPONENT",
  displayUpdateComponents: "DISPLAY_UPDATE_COMPONENT",
  displayUpdateFlowData: "DISPLAY_UPDATE_FLOW_DATA",
  checkAuthToken: "CHECK_AUTH_TOKEN",
  setAuthToken: "SET_AUTH_TOKEN",
  updateTree: "UPDATE_TREE",
  updateTreeDataForScript: "UPDATE_TREE_DATA_FOR_SCRIPT",
  refreshTree: "REFRESH_TREE",
  setActiveComponent: "SET_ACTIVE_COMPONENT",
  showQuerySheet: "SHOW_QUERY_SHEET",
  lastComponentDeleted: "LAST_COMPONENT_DELETED",

  saveComponentConfig: "SAVE_COMPONENT_CONFIG",
  saveFlowTab: "SAVE_FLOW_TAB",
  saveFlowTabComLevel: "SAVE_FLOW_TAB_COM_LEVEL",
  saveConnectionTab: "SAVE_CONNECTION_TAB",
  updateGridData: "UPDATE_GRID_DATA",
  runJSFlowTab: "RUN_JS_FLOW_TAB",
  runJSConnectionTab: "RUN_JS_CONNECTION_TAB",

  datasourceUpdated: "DATASOURCE_UPDATED",
  componentUpdated: "COMPONENT_UPDATED",
  componentTextValidation: "COMPONENT_TEXT_VALIDATION",
  componentDependencyDetaching: "COMPONENT_DEPENDENCY_DETACHING",

  flowUpdated: "FLOW_UPDATED",
  connectionUpdated: "CONNECTION_UPDATED",

  scriptUpdated: "SCRIPT_UPDATED",
  projectUpdated: "PROJECT_UPDATED",
  treeUpdated: "TREE_UPDATED",
  treeUpdateDatasource: "TREE_UPDATE_DATASOURCE",
  groupSelect: "GROUP_SELECT",
  updateFileName: "UPDATE_FILE_NAME",
  updateMcsvFileName: "UPDATE_MCSV_FILE_NAME",
  reportDataReceived: "REPORT_DATA_RECEIVED",
  subscribeManualPickElementDetailStarted: "MANUAL_PICK_ELEMENT_DETAIL_STARTED",
  subscribeManualPickElementDetailEnded: "MANUAL_PICK_ELEMENT_DETAIL_ENDED",
  subscribeManualScreenCaptureStarted: "MANUAL_SCREEN_CAPTURE_STARTED",
  subscribeManualScreenCaptureEnded: "MANUAL_SCREEN_CAPTURE_ENDED",
  findByClickOfElement: "FIND_BY_CLICK_OF_ELEMENT",
  updateContentIframe: "UPDATE_CONTENT_IFRAME",
  updateForceDatasheet: "UPDATE_FORCE_DATASHEET",
  updateWireMock: "VIRTUALIZATION",
  updateForceAuthDatasheet: "UPDATE_FORCE_AUTH_DATASHEET",
  updateContentComponent: "UPDATE_CONTENT_COMPONENT",
  activeComponent: "ACTIVE_COMPONENT",
  setFlowActiveComponent: "SET_FLOW_ACTIVE_COMPONENT",
  contentIframeUpdated: "CONTENT_IFRAME_UPDATED",
  removeAttrToContentIframe: "REMOVE_ATTR_TO_CONTENT_IFRAME",
  createDatasourceForComponent: "CREATE_DATASOURCE_FOR_COMPONENT",
  runAgentScript: "RUN_AGENT_SCRIPT",
  runDbTest: "RUN_DB_TEST",
  runDbQueryResult: "RUN_DB_QUERY_RESULT",
  componentMode: "COMPONENT_MODE",
  iframesShow: "IFRAMES_SHOW",
  iframeRecordToggle: "IFRAME_RECORD_TOGGLE",
  iframeListener: "IFRAME_LISTENER",
  createMouseHoverActivity: "CREATE_MOUSE_HOVER_ACTIVITY",
  saveUpdatedConnection: "UPDATED_CONNECTION",

  flowData: "FLOW_DATA",
  redirectFlow: "FLOW_REDIRECT",
  showUpdatedFlowData: "SHOW_UPDATED_FLOW_DATA",

  connectionData: "CONNECTION_DATA",
  showUpdatedConnectionData: "SHOW_UPDATED_CONNECTION_DATA",
  debugStepRun: "DEBUG_STEP_RUN",
  debugRunAll: "DEBUG_RUN_ALL",
  editeTreeName: "EDITE_TREE_NAME",
  gitFlowEvent: "GIT_FLOW_EVENT",
  virtualizationEvent: "VIRTUALIZATION_EVENT",
  gitLogEvent: "GIT_LOG_EVENT",
  iframeLoad: "IFRAME_LOAD",
  rightBlocksResize: "RIGHT_BLOCKS_RESIZE",
  saveFileData: "SAVE_FILE_DATA",
  saveMcsvFileData: "SAVE_MCSV_FILE_DATA",
  importFile: "IMPORT_FILE",
  importMcsvFile: "IMPORT_MCSV_FILE",
  removeJSFile: "REMOVE_JS_FILE",
  swapActivity: "SWAP_ACTIVITY",
  swapApiActivity: "SWAP_API_ACTIVITY",
  displayUpdateActivities: "DISPLAY_UPDATE_ACTIVITIES",
  removeColumn: "REMOVE_COLUMN",
  handleDBStoreColumnVariable: "HANDLE_DB_STORE_COLUMN_VARIABLE",
  handleDBLoopColumnVariable: "HANDLE_DB_LOOP_COLUMN_VARIABLE",
  handleDatasheetEncryptColumn: "HANDLE_DATASHEET_ENCRYPT_COLUMN",
  handleDatasheetUserVariable: "HANDLE_DATASHEET_USER_VARIABLE",
  handleMasterDatasheetEncryptColumn: "HANDLE_MASTER_DATASHEET_ENCRYPT_COLUMN",
  handleMasterDatasheetDecryptColumn: "HANDLE_MASTER_DATASHEET_DECRYPT_COLUMN",
  dragDropComplete: "DRAG_DROP_COMPLETE",
  menuItemClick: "MENU_ITEM_CLICK",
  selectDate: "SELECT_DATE",
  selectableClick: "SELECTABLE_CLICK",
  resizingComplete: "RESIZING_COMPLETE",
  spinnerClick: "SPINNER_CLICK",
  contextClick: "CONTEXT_CLICK",
  doubleClick: "DOUBLE_CLICK",
  keyPress: "KEY_PRESS",
  click: "CLICK",
  downloadClick: "DOWNLOAD_CLICK",
  tooltip: "TOOLTIP",
  slideComplete: "SLIDE_COMPLETE",
  autoComplete: "AUTO_COMPLETE",
  startScreenCapture: "START_SCREEN_CAPTURE",
  screenShotURLGenerated: "SCREEN_SHOT_URL_GENERATED",
  iframeCapturingPathToggle: "IFRAME_CAPTURING_PATH_TOGGLE",
  saveFindByClickElement: "SAVE_FIND_BY_CLICK_ELEMENT",
  sendComponentData: "SEND_COMPONENT_DATA",
  setWindowActivityEditStep: "SET_WINDOW_ACTIVITY_EDIT_STEP",
  windowPopperReload: "WINDOW_POPPER_RELOAD",
  componentModeUiUpdate: "COMPONENT_MODE_UI_UPDATE",
  validationModeUiUpdate: "VALIDATION_MODE_UI_UPDATE",
  setNewCustomActivity: "SET_NEW_CUSTOM_ACTIVITY",
  treeNodeName: "TREE_NODE_NAME",
  treeGitFlow: "TREE_GIT_FLOW",
  treeVirtualization: "TREE_VIRTUALIZATION",
  treeGitFlowUpdated: "TREE_GIT_FLOW_UPDATED",
  treeVirtualizationUpdated: "TREE_VIRTUALIZATION_UPDATED",
  treeGitLog: "TREE_GIT_LOG",
  treeGitLogUpdated: "TREE_GIT_LOG_UPDATED",
  treeNodeNameUpdated: "Tree_Node_NAME_UPDATED",
  changeHelpData: "CHANGE_HELP_DATA",
  createAutoComponent: "CREATE_AUTO_COMPONENT",
  handleEditRowItemModal: "HANDLE_EDIT_ROW_ITEM_MODAL",
  handleEditChildRowItemModal: "HANDLE_EDIT_CHILD_ROW_ITEM_MODAL",
  handleCopyChildRowItemModal: "HANDLE_COPY_CHILD_ROW_ITEM_MODAL",
  handleDatasheetReplicateModal: "HANDLE_DATASHEET_REPLICATE_MODAL",
  handleDatasheetDescriptionModal: "HANDLE_DATASHEET_DESCRIPTION_MODAL",
  handleDatasheetAddRowModal: "HANDLE_DATASHEET_ADD_ROW_MODAL",
  handleDatasheetRemovesModal: "HANDLE_DATASHEET_REMOVES_MODAL",
  handleApiDatasheetReplicateModal: "HANDLE_API_DATASHEET_REPLICATE_MODAL",
  handleApiDatasheetDescriptionModal: "HANDLE_API_DATASHEET_DESCRIPTION_MODAL",
  handleApiDatasheetAddRowModal: "HANDLE_API_DATASHEET_ADD_ROW_MODAL",
  handleApiDatasheetRemovesModal: "HANDLE_API_DATASHEET_REMOVES_MODAL",
  updateDatasheetReplicateContent: "UPDATE_DATASHEET_REPLICATE_CONTENT",
  updateOptimizedDatasheetReplicateContent: "UPDATE_OPTIMIZED_DATASHEET_REPLICATE_CONTENT",
  saveOptimizedDatasheetTab: "SAVE_OPTIMIZED_DATA_SHEET_TAB",

  updateDatasheetRemovesContent: "UPDATE_DATASHEET_REMOVES_CONTENT",
  verifyAndSaveNewActivity: "VERIFY_AND_SAVE_NEW_ACTIVITY",
  updateTestDescriptionDatasheet: "UPDATE_TEST_DESCRIPTION_DATASHEET",
  displayUpdatedTestDescription: "DISPLAY_UPDATED_TEST_DESCRIPTION",
  handleAddTimer: "TOOLBAR_TIMER",
  handleAssertToggle: "TOOLBAR_ASSERT",
  assertColor: "ASSERT_COLOR_STATE",
  handleJsAdd: "TOOLBAR_JS",
  capturingAbsolutePath: "TOOLBAR_CAPTURING_ABSOLUTE_PATH",
  changePath: "CHANGE_PATH",
  isCapturingAbsolutePath: "CAPTURING_ABSOLUTE_PATH_STATE",
  toggleHideTree: "TOGGLE_HIDE_TREE",
  handleDatasheetDeleteRowConfirm: "HANDLE_DATASHEET_DELETE_ROW_CONFIRM",
  handleApiDatasheetDeleteRowConfirm: "HANDLE_API_DATASHEET_DELETE_ROW_CONFIRM",
  handleDatasheetDeleteColumnConfirm: "HANDLE_DATASHEET_DELETE_COLUMN_CONFIRM",
  handleApiDatasheetDeleteColumnConfirm: "HANDLE_API_DATASHEET_DELETE_COLUMN_CONFIRM",
  handleDatasheetDeleteRowConfirmYes: "HANDLE_DATASHEET_DELETE_ROW_CONFIRM_YES",
  handleListenBreakpointChange: "HANDLE_LISTEN_BREAKPOINT_CHANGE",

  flowHandleDatasheetDeleteRowConfirmYes: "FLOW_HANDLE_DATASHEET_DELETE_ROW_CONFIRM_YES",
  connectionHandleDatasheetDeleteRowConfirmYes: "CONNECTION_HANDLE_DATASHEET_DELETE_ROW_CONFIRM_YES",

  handleDatasheetAddingManualRow: "HANDLE_DATASHEET_ADD_MANUAL_ROW",
  handleDatasheetSetData: "HANDLE_DATASHEET_SET_DATA",
  handleDatasheetSetDataMSCV: "HANDLE_DATASHEET_SET_DATA_MCSV",
  handleApiDatasheetSetData: "HANDLE_API_DATASHEET_SET_DATA",
  handleDatasheetAddManualRowFunction: "HANDLE_DATASHEET_ADD_MANUAL_ROW_FUNCTION",
  handleDatasheetDeleteColumnConfirmYes: "HANDLE_DATASHEET_DELETE_COLUMN_CONFIRM_YES",
  handleDatasheetAddColumnModal: "HANDLE_DATASHEET_ADD_COLUMN_MODAL",
  handleDatasheetAddColumn: "HANDLE_DATASHEET_ADD_COLUMN",
  handleDatasheetFind: "HANDLE_DATASHEET_FIND",
  handleDatasheetFindNext: "HANDLE_DATASHEET_FIND_NEXT",
  handleDatasheetReplace: "HANDLE_DATASHEET_REPLACE",
  handleDatasheetReplaceAll: "HANDLE_DATASHEET_REPLACE_ALL",
  handleResetFind: "HANDLE_RESET_FIND",
  updateDatasheetAddColumnContent: "HANDLE_DATASHEET_ADD_COLUMN_CONTENT",
  handleAddModalInputActivity: "HANDLE_ADD_MODAL_INPUT_ACTIVITY",
  projectUserAddVariableModal: "PROJECT_USER_ADD_VARIABLE_MODAL",
  projectUserEditVariableModal: "PROJECT_USER_EDIT_VARIABLE_MODAL",

  projectUserAddConnectionModal: "PROJECT_USER_ADD_CONNECTION_MODAL",
  projectUserEditConnectionModal: "PROJECT_USER_EDIT_CONNECTION_MODAL",

  updateSimpleLoopActivityModal: "UPDATE_SIMPLE_LOOP_ACTIVITY_MODAL",
  updateNodeName: "UPDATE_NODE_NAME",
  setNumberOfColumns: "SET_NUMBER_OF_COLUMNS",
  setMcsvNumberOfColumns: "SET_MCSV_NUMBER_OF_COLUMNS",
  copyComponentRefreshProjects: "COPY_COMPONENT_REFRESH_PROJECTS",
  refreshProjects: "REFRESH_PROJECTS",
  handleSaveApiActivity: "HANDLE_SAVE_API_ACTIVITY",
  handleRequestApi: "HANDLE_REQUEST_API",
  publishAPIRec: "PUBLISH_API_REC",
  publishGetProjects: "PUBLISH_GET_PROJECTS",
  publishConnection: "PUBLISH_CONNECTION",
  saveDatasheetTab: "SAVE_DATASHEET_TAB",
  apiManualSelectActivity: "API_MANUAL_SELECT_ACTIVITY",
  manualUpdateApiRec: "MANUAL_UPDATE_API_REC",
  publishApiFormReset: "PUBLISH_API_FORM_RESET",
  taskRunningFinished: "TASK_RUNNING_FINISHED",
  responseFromExeReceived: "RESPONSE_FROM_EXE_RECEIVED",
  componentTestResultSaved: "COMPONENT_TEST_RESULT_SAVED",
  runButtonClicked: "RUN_BUTTON_CLICKED",
  apiModuleSelected: "API_MODULE_SELECTED",
  jsonEditorReload: "JSON_EDITOR_RELOAD",
  responsejsonEditorReload: "RESPONSE_JSON_EDITOR_RELOAD",
  resetResponse: "RESET_RESPONSE",
  isResponseHeader: "IS_RESPONSE_HEADER",
  isRequestHeader: "IS_REQUEST_HEADER",
  moveToDatasheet: "MOVE_TO_DATASHEET",
  changeApiChildTab: "CHANGE_API_CHILD_TAB",
  handleSaveApiConfig: "HANDLE_SAVE_API_CONFIG",
  agentConnectionOn: "AGENT_CONNECTION_ON",
  agentConnectionOff: "AGENT_CONNECTION_OFF",

  handleCurlActivity: "HANDLE_CURL_ACTIVITY",
  handleSaveCurl: "HANDLE_SAVE_CURL",
  handleSaveHeader: "HANDLE_SAVE_HEADER",
  saveParameter: "HANDLE_SAVE_PARAMETER",
  closeParameter: "CLOSE_PARAMETER",

  activeNumberTab: "ACTIVE_NUMBERS_TAB",
  shareActivitiesData: "SHARE_ACTIVITIES_DATA",
  selectResponseHeaderTab: "SELECT_RESPONSE_HEADER_TAB",

  fileUploadUpdateTree: "UPDATE_TREE_FILE_UPLOAD",

  tableHeaderChange: "TABLE_HEADER_Change",

  apiDatasheetUpload: "API_DATASHEET_UPLOAD",
  apiDatasheetDownload: "API_DATASHEET_DOWNLOAD",
  apiDatasheetTestGeneration: "API_DATASHEET_TEST_GENERATION",
  setActiveDataMatrixRow: "SET_ACTIVE_DATAMATRIX_ROW",
  getActiveDataMatrixRow: "GET_ACTIVE_DATAMATRIX_ROW",
  checkColumnParameterized: "CHECK_COLUMN_PARAMETERIZED",
  columnParameterizedResult: "COLUMN_PARAMETERIZED_RESULT",
  removeColumnParameterization: "REMOVE_COLUMN_PARAMETERIZATION",
  regenerateCurlFromRequest: "REGENERATE_CURL_FROM_REQUEST",
  pageElementsCaptured: "PAGE_ELEMENTS_CAPTURED",
  refreshPageElements: "REFRESH_PAGE_ELEMENTS"
};
